import { Injectable } from '@angular/core';
import { TaskTagService } from '../../common/services/task-tag.service';

@Injectable({
  providedIn: 'root',
})
export class ErpCrisisTaskTagService extends TaskTagService {
  // tslint:disable:variable-name
  protected ParseTask = Parse.Object.extend('GDCTask');
  protected ParseTag = Parse.Object.extend('GDCTag');
  protected ParseTaskTag = Parse.Object.extend('GDCTaskTag');
  // tslint:enabled
}
